export default __webpack_public_path__ + "static/1-38-0-search-459f2bc17035371511b593863176743a.png";